import { MenuEntry } from '@src/menu-entry';
import DocumentHistoryMenu from '@src/document-history/menu';

export default MenuEntry.create()
    .setTitle('Entwicklung')
    .setChildren([
        MenuEntry.create()
            .setTitle('Icons')
            .setRoute('icon-overview'),
        MenuEntry.create()
            .setTitle('Sandbox')
            .setRoute('sandbox'),
        DocumentHistoryMenu,
    ]);
